// hooks/useNavigation.js
import { useState } from 'react';

export const useNavigation = () => {
  const [currentPath, setCurrentPath] = useState([]);
  const [viewMode, setViewMode] = useState('list');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortMethod, setSortMethod] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [filesCurrentPath, setFilesCurrentPath] = useState([]);

  // Handle navigation - back button click
  const handleBackClick = () => {
    if (currentPath.length === 0) return;

    const newPath = [...currentPath];
    newPath.pop();
    setCurrentPath(newPath);
  };

  // Handle navigation - category click
  const handleCategoryClick = (categoryOrPath) => {
    if (Array.isArray(categoryOrPath)) {
      // If it's already an array, use it as the new path
      setCurrentPath(categoryOrPath);
    } else if (typeof categoryOrPath === 'string') {
      // If it's a string, add it to current path
      setCurrentPath([...currentPath, categoryOrPath]);
    } else {
      // If it's empty/null, go to root
      setCurrentPath([]);
    }
  };

  // Handle folder navigation within Files category
const handleFilesFolderClick = (folderName) => {
  setFilesCurrentPath(prev => [...prev, folderName]);
};

// Handle back navigation within Files
const handleFilesBackClick = () => {
  if (filesCurrentPath.length > 0) {
    setFilesCurrentPath(prev => prev.slice(0, -1));
  }
};

// Reset folder navigation when changing categories
const resetFolderNavigation = () => {
  setFilesCurrentPath([]);
};

  // Navigate to root
  const navigateToRoot = () => {
    setCurrentPath([]);
    setSearchTerm('');
  };

  // Navigate to specific path
  const navigateTo = (newPath) => {
    setCurrentPath(newPath);
  };

  // Handle search
  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  // Handle sort
  const handleSort = (method, order) => {
    setSortMethod(method);
    setSortOrder(order);
  };

  // Reset navigation state
  const resetNavigation = () => {
    setCurrentPath([]);
    setSearchTerm('');
    setSortMethod('name');
    setSortOrder('asc');
    setFilesCurrentPath([]);
  };

  return {
    // State
    currentPath,
    filesCurrentPath,
    viewMode,
    searchTerm,
    sortMethod,
    sortOrder,

    // Setters
    setCurrentPath,
    setFilesCurrentPath,
    setViewMode,
    setSearchTerm,
    setSortMethod,
    setSortOrder,

    // Actions
    handleBackClick,
    handleCategoryClick,
    handleFilesFolderClick, 
  handleFilesBackClick,
  resetFolderNavigation,
    navigateToRoot,
    navigateTo,
    handleSearch,
    handleSort,
    resetNavigation
  };
};